import { ReservationServiceTypeDetailsModel } from "src/models/ReservationServiceTypeDetailsModel";

export const transformToServiceTypeDetails = (data, services = []) => {
    if (!data) return null;

    data.ServiceUnitRequestResults?.forEach((request) => {
        request.Units.forEach((units) => {
            units.SupplementResults?.forEach((supp) => {
                supp.Selected = supp.Included ?? false;
            });
            units.DiscountResults?.forEach((supp) => {
                supp.UserIncluded = supp.Included ?? false;
            });
        });
    });

    return { ...new ReservationServiceTypeDetailsModel(data, services) };
};

export const calculateTotalServiceTypeCost = (unit) => {
    const supplementsCost =
        unit.SupplementResults?.reduce(
            (sum, s) => (!s.Included && s.Selected ? sum + s.Value.Total : sum),
            0) || 0;

    const discountTotal =
        unit.DiscountResults?.reduce(
            (sum, discount) => (discount.Included ? sum + discount.Value.Total : sum),
            0) || 0;

    const userSelectedDiscount =
        unit.DiscountResults?.reduce(
            (sum, discount) => (discount.UserIncluded ? sum + discount.Value.Total : sum),
            0) || 0;

    const netDiscountTotal = userSelectedDiscount - discountTotal;

    const baseCost = unit.ClientNetSell + unit.ClientNetSellTax;

    return (baseCost + supplementsCost + netDiscountTotal);
};